import { createGlobalStyle } from "@bestowinc/tinkertoy-shell-deps/styled-components";

/**
 * The browser reset + typography normalization applied once at the shell root,
 * rendered by {@link InternalTinkertoyProvider} inside the shell's
 * `<ThemeProvider>`.
 *
 * This is the production counterpart to the Remix apps' app-level `GlobalStyle`
 * (`apps/enrollment-composer/app/GlobalStyle.ts`) and the module-storybook's
 * `ModuleLayoutGlobalStyle` decorator. Layout modules and views assume it
 * exists — without it, elements not wrapped in a Kindred typography primitive
 * fall back to the browser's default serif (e.g. bare step numbers rendering in
 * Times), and default UA heading/paragraph margins reappear and throw off
 * spacing.
 *
 * The single most important rule is the `*` font-family safety net: it applies
 * the theme's body font to every element so stray text inherits the correct
 * family instead of the UA default.
 */
export const ShellGlobalStyle = createGlobalStyle`
  html,
  body {
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
  }

  body {
    background-color: ${({ theme }) => theme.colors.background.surface100};
  }

  * {
    /* Safety net: apply the body font family everywhere so any text missing an
       explicit font-family style inherits it instead of the UA default serif. */
    font-family: ${({ theme }) => theme.typography.base.bodyProps.fontFamily};
    box-sizing: border-box;
  }

  #root {
    height: 100%;
    margin: 0;
    padding: 0;
  }

  blockquote,
  dl,
  dd,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  hr,
  figure,
  p,
  pre {
    margin: 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: inherit;
    font-weight: inherit;
  }

  hr {
    border: 1px solid ${({ theme }) => theme.colors.neutral[200]};
  }

  ol,
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  img,
  svg,
  video,
  canvas,
  audio,
  iframe,
  embed,
  object {
    display: block;
  }

  img,
  video {
    max-width: 100%;
    height: auto;
  }

  button {
    border-width: 0;

    &:focus {
      outline: 1px dotted;
      outline: 5px auto -webkit-focus-ring-color;
    }
  }
`;
